export enum PaymentStatusEnum
{
    DRAFT = 'draft',
    COMPLETED = 'completed',
}
